export default (context) => {
    let video = document.getElementById('player-component__video')
    let music = document.getElementById(`${context.music.id}`)
    if(video) {
        let button = document.getElementById('player-component__button')
        if(button.style.display === 'block') {
            if(music) music.play()

            let playPromise  = video.play()
            if (playPromise !== undefined) {
                playPromise.then(function() {
                }).catch(function(error) {
                    console.log(error)
                });
            }

            button.style.display = 'none'
        } else {
            if(music) music.pause()
            video.pause()
            button.style.display = 'block'
        }
    }
}